module.exports = __webpack_public_path__ + "media/rutin-small.ab5f77ec.mp4";